import { useEffect, useRef, useState } from 'react'
import { Popover } from '@mantine/core'
import { IconChevronDown } from '@tabler/icons-react'

const holdLabels = {
    fulfillment_order_shopify: 'Commandes Shopify',
    fulfillment_order_retailer: 'Commandes revendeurs',
    fulfillment_order_service_case: 'SAV',
    fulfillment_order_transfer: 'Transferts',
    fulfillment_order_manual: 'Préparations manuelles',
    retailer_estimate: 'Devis revendeurs',
    assembly: 'Assemblages',
}

export default function ComponentHoldQuantity({ quantity, breakdown, locationName }) {
    const [opened, setOpened] = useState(false)
    const pinned = useRef(false)
    const closeTimer = useRef(null)
    useEffect(() => () => clearTimeout(closeTimer.current), [])

    const close = () => {
        clearTimeout(closeTimer.current)
        pinned.current = false
        setOpened(false)
    }
    const open = () => {
        clearTimeout(closeTimer.current)
        setOpened(true)
    }
    const leave = () => {
        clearTimeout(closeTimer.current)
        closeTimer.current = setTimeout(() => {
            if (!pinned.current) setOpened(false)
        }, 180)
    }
    const entries = Object.entries(holdLabels)
        .map(([key, label]) => ({ label, quantity: Number(breakdown?.[key] ?? 0) }))
        .filter((entry) => entry.quantity > 0)
    const hasDetail = entries.length > 0 && entries.reduce((sum, entry) => sum + entry.quantity, 0) === Number(quantity)
    const format = (value) => Number(value).toLocaleString('fr-FR')

    return <Popover opened={opened} onChange={(value) => value ? open() : close()}
        position="bottom" width={300} shadow="md" radius="md" withinPortal
        closeOnEscape returnFocus={false}>
        <Popover.Target>
            <button type="button"
                className="inline-flex min-h-11 min-w-11 items-center justify-center gap-1 rounded px-2 text-indigo-600 tabular-nums hover:underline focus-visible:outline-2 focus-visible:outline-baltic"
                aria-label={`${format(quantity)} réservés à ${locationName} : voir le détail`}
                onMouseEnter={open} onMouseLeave={leave}
                onFocus={open} onBlur={leave}
                onKeyDown={(event) => { if (event.key === 'Escape') close() }}
                onClick={() => {
                    if (pinned.current) close()
                    else { pinned.current = true; open() }
                }}>
                {format(quantity)}
                <IconChevronDown size={14} aria-hidden="true" className={opened ? 'rotate-180' : undefined} />
            </button>
        </Popover.Target>
        <Popover.Dropdown p="md" onMouseEnter={open} onMouseLeave={leave}
            style={{ maxWidth: 'calc(100vw - 24px)', maxHeight: 'min(480px, 70dvh)', overflowY: 'auto' }}>
            <p className="mb-3 truncate text-sm font-medium" title={locationName}>{locationName}</p>
            {hasDetail ? <dl className="space-y-2">
                {entries.map((entry) => <div key={entry.label} className="flex items-baseline justify-between gap-4 text-sm">
                    <dt className="text-gray-600">{entry.label}</dt>
                    <dd className="shrink-0 tabular-nums">{format(entry.quantity)}</dd>
                </div>)}
                <div className="flex justify-between gap-4 border-t border-gray-100 pt-3 text-sm font-medium">
                    <dt>Total réservé</dt><dd className="tabular-nums">{format(quantity)}</dd>
                </div>
            </dl> : <p className="text-sm text-gray-500">Détail indisponible. Recalculez les réservés pour le mettre à jour.</p>}
        </Popover.Dropdown>
    </Popover>
}
